import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Button } from '@redshelf/redshelf-ui';
import { uploaderPdfToIframe } from 'utilities/printUtilities';

const useStyles = makeStyles((theme) => {
  return {
    toastOpenPDF: {
      marginLeft: 'auto',
      marginRight: theme.spacing(1.25),
    },
  };
});

export default function ToastPrintButton({ pk }) {
  const classes = useStyles();

  return (
    <Button
      className={classes.toastOpenPDF}
      size="small"
      variant="secondary"
      onClick={() => uploaderPdfToIframe(pk)}
      aria-label="Print PDF"
    >
      Print
    </Button>
  );
}
